/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppConfigService } from '@app/common/app-config.service';
import { UserPreferenceService } from '@app/common/user-preference.service';

@Component({
  selector: 'app-work-item-assignee-status',
  templateUrl: './work-item-assignee-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkItemAssigneeStatusComponent implements OnInit {
  @Input() state;
  @Input() showLabel = true;

  userId = '';
  colorAssigntoColumn = false;
  constructor(private appConfigService: AppConfigService, private uerPreferenceService: UserPreferenceService) {}

  ngOnInit(): void {
    this.userId = this.appConfigService.getUserId();
    this.colorAssigntoColumn = this.uerPreferenceService.getUserPreferenceFromCache('colorAssigntoColumn');
  }
}
